import { render, staticRenderFns } from "./homepage-auth.vue?vue&type=template&id=12c4d020&"
import script from "./homepage-auth.vue?vue&type=script&lang=js&"
export * from "./homepage-auth.vue?vue&type=script&lang=js&"
import style0 from "./homepage-auth.vue?vue&type=style&index=0&id=12c4d020&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports